import React, { Component } from "react";
import {
  Form,
  Select,
  Button,
  Input,
  DatePicker,
  TimePicker,
  Modal,
  Checkbox,
  Upload,
  Row,
  Col,
  Space,
  message,
  Table,
  Card,
  Tooltip,
  Spin,
  Popconfirm,
  Collapse
} from "antd";
import { Autocomplete } from "@react-google-maps/api";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";

import config from "../config";
import { format, addMinutes } from "date-fns";
import { Link } from "react-router-dom";
import CompanyAutocomplete from "./CompanyAutocomplete";
import GoogleMapForDirection from "./GoogleMapForDirection";
// import { useGoogleMapRef  } from "./GoogleMapForDirection";
import AssignRouteStore from "../store/AssignRouteStore";

import dayjs from "dayjs";
import CompanyStore from "../store/CompanyStore";
import DeleteConfirm from "./DeleteConfirm";
import L from "leaflet";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import {
  CloseOutlined,
  DeleteFilled,
  DeleteOutlined,
  PlusOutlined,
  PlusCircleOutlined,
  ExclamationCircleFilled,
  QuestionCircleOutlined
} from "@ant-design/icons";
import axios from "axios";
const inputStyle = {
  boxSizing: "border-box",
  border: "1px solid transparent",

  height: "32px",
  padding: "0 12px",
  borderRadius: "3px",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
  fontSize: "14px",
  outline: "none",
  textOverflow: "ellipses",
  // position: "absolute",
  left: "50%",
  // marginLeft: "-120px",
};

const formCss = {
  width: "285px",
  background: "rgb(255, 255, 255)",
  margin: "20px",
  padding: "13px",
  border: "1px solid",
  height: "620px",
  "overflow-y": "scroll",
};

const getDragItems = () => {
  return (
    [
      { id: "1", point: "Point 1", address: "", lat: "", lng: "", searchAddress: "", dateTimeRange: "" },
      { id: "2", point: "Point 2", address: "", lat: "", lng: "", searchAddress: "", dateTimeRange: "" }
    ]
  )
};

class AssignRouteAddNew extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);

    this.state = {
      pointsWay: [],
      companyId: "",
      loadList: 0,
      offset: "",
      limit: "",
      geofence: "",
      searchOnMap: true,
      history: "",
      defaultAddValue: "searchOnMap",
      fromDate: dayjs(),
      toDate: dayjs(),
      fromTime: "",
      toTime: "",
      vehicleId: "",
      routePoints: [],
      startPoint: true,  //false
      endPoint: false,
      pickUpDrop: false,
      startObj: "",
      endObj: "",
      loadState: 0,
      origin: "",
      destination: "",
      companyCustomer: false,
      studentCustomer: false,
      addAddress: true,
      stId: "",
      pickUpDropObj: {},
      endTimeShowingTbl: "00:00",
      addressInputText: "",
      routePopupShow: false,
      geofencePointsArrayObj: [],
      clearMapBtn: false,
      routeDeviationAlert: true,
      geofenceInfoObj: {},
      geofenceFormatedPoints: [],
      tripId: "",
      dayofweeks: [],
      historyInfoObj: {},
      positionLatLongArray: [],
      loadingSpinner: false,
      wayPointId: 1,
      travelDistance: "",
      travelDuration: "",
      dragItems: [],
      pointName: "Point 1",
      selectedItemId: "1",
      pointNameInput: "", // New state to track the input value
      zoomLevel: 5,
      sourcesList: [],
      originAddress: null,
      destinationAddress: null
    };
    this.originRef = React.createRef();
    this.autocompleteRef = React.createRef();
    this.googleMapRef = React.createRef();
    this.mapRef = React.createRef();
    // this.state = { dateFormatList: ["DD/MM/YYYY"], loading: false };
    this.AssignRouteStore = new AssignRouteStore(this);
    this.companyStore = new CompanyStore(this);
  }
  onSequenceTableRecordDelete = async (record) => {
    console.log(record, "ca");

    if (record.sequenceId) {
      if (Number(record.sequenceId) === 1) {
        console.log("called");
        this.setState({ origin: null, startObj: "" });
      } else if (Number(record.sequenceId) === 2) {
        this.setState({ destination: null, endObj: "" });
      }
      const filterRecord = this.state.routePoints.filter((val) => {
        return Number(record.sequenceId) !== Number(val.sequenceId);
      });
      await this.setState({ routePoints: filterRecord });
      if (this.state.geofencePointsArrayObj?.length > 0) {
        let filterGeofence = await this.state.geofencePointsArrayObj.filter(
          (val) => {
            return Number(record.sequenceId) !== Number(val.sequenceId);
          }
        );
        await this.setState({ geofencePointsArrayObj: filterGeofence });
        console.log(filterGeofence, this.state.geofencePointsArrayObj, record);
      }
      console.log(filterRecord);
    } else if (Number(record.wayPointId)) {
      console.log(record);
      const filterRecord = this.state.routePoints.filter((val) => {
        return Number(record.wayPointId) !== Number(val.wayPointId);
      });
      await this.setState({ routePoints: filterRecord });
      const pointsWay = this.state.pointsWay.filter((val) => {
        return Number(record.wayPointId) !== Number(val.wayPointId);
      });
      // pointsWay
      console.log(pointsWay);
      await this.setState({ pointsWay: pointsWay });
    }

    // this.setState({
    //   origin: "",
    //   destination: "",
    //   pointsWay: [],
    //   clearMapBtn: true,
    // });
  };

  layout = {
    labelCol: { span: 16 },
    wrapperCol: { span: 16 },
  };

  async componentDidMount() {
    this.setState({ companyCustomer: true });
    //this.setState({ dragItems: getDragItems() });
    this.formRef.current.setFieldsValue({ pointName: "Point 1" });

    this.columns = [
      {
        title: "Sequence No",
        dataIndex: "sequenceNo",
        key: "sequenceNo",
      },
      {
        title: "PickUp Time",
        dataIndex: "picktime",
        key: "age",
      },
      {
        title: "Action",
        dataIndex: "",
        key: "",
        render: (_, record) => {
          return (
            <>
              <Space>
                <DeleteConfirm
                  onConfirm={(e) => {
                    // this.onDelete(record);
                    console.log(record);
                    this.onSequenceTableRecordDelete(record);
                  }}
                >
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <DeleteFilled style={{ color: config.deleteColor }} />
                  </Link>
                </DeleteConfirm>
              </Space>
            </>
          );
        },
      },
    ];

    const id = this.props.params.id;

    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
    }



    if (id) {
      this.fillData(id);
    }
  }

  componentDidUpdate() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    });
  }
  fillData = async (id) => {
    try {
      // FORM FIELDS
      await this.setState({ loadingSpinner: true });
      const record = await this.AssignRouteStore.getRouteById(id);
      // debugger
      console.log("record***********", record);
      //await this.AssignRouteStore.getGeoData(record.companyId);
      await this.setState({ companyId: record.companyId }, async () => {
        await this.handleStopsSourceChange(record.stopSource);
      });
      const singleData = await this.companyStore.getCompanyDataById(
        record.companyId
      );

      this.formRef.current.setFieldsValue({
        routeName: record.routeName,
        stopsSource: record.stopSource,
        companyId: singleData
      });



      await this.setState({ routeId: record.routeId });


      // MARKERS / LOCATIONS
      let points = record.RoutePoints || [];
      console.log("points", points);
      // debugger
      let dragItems = points.map((p, idx) => ({
        id: "pt_" + idx,
        point: p.sequenceNo.split("-")[0].trim() ? p.sequenceNo.split("-")[0].trim() : `Point ${idx + 1}`,
        address: this.formatAddress(p.sequenceNo),
        lat: Number(p.latitude),
        lng: Number(p.longitude),
        routeZoneId: p.routeZoneId
      }));

      // FIRST → origin
      // LAST → destination
      this.setState({
        dragItems,
        origin: dragItems.length > 0 ? { lat: dragItems[0].lat, lng: dragItems[0].lng } : null,
        originAddress: dragItems.length ? dragItems[0].address : null,
        destination:
          dragItems.length > 1
            ? { lat: dragItems[dragItems.length - 1].lat, lng: dragItems[dragItems.length - 1].lng }
            : null,
        destinationAddress: dragItems.length > 1 ? dragItems[dragItems.length - 1].address : null,
        // WAYPOINTS (middle points)
        pointsWay:
          dragItems.length > 2
            ? dragItems.slice(1, dragItems.length - 1).map((d, i) => ({
              wayPointId: i + 1,
              location: { lat: d.lat, lng: d.lng },
              address: d.address
            }))
            : [],



      }, () => {
        console.log("destinationAddress ✔", this.state.destinationAddress);
      });
      await this.setState({ loadingSpinner: false });

      // SET DISTANCE & TIME
      const last = points[points.length - 1];
      console.log(last);
      this.setState({
        travelDistance: last.travelDistance ? last.travelDistance : 0,
        travelTime: last.travelDuration ? last.travelDuration : 0,
      });


      // await this.setState({
      //   originAddress: dragItems.length ? dragItems[0].address : null,
      //   destinationAddress: dragItems.length > 1 ? dragItems[dragItems.length - 1].address : null
      // });

      message.success("Data loaded for edit");

      setTimeout(() => {
        if (this.mapRef.current && this.mapRef.current.fitToMarkers) {
          this.mapRef.current.fitToMarkers();
        }
      }, 500);
    } catch (err) {
      console.error(err);
    }
  };

  extractAddress(sequenceNo, pointNumber) {
    if (!sequenceNo) return `Point ${pointNumber}`;

    // Example seq: "Point 1 - Bur Dubai - UAE"
    let parts = sequenceNo.split(" - ");

    // Force correct "Point X"
    parts[0] = `Point ${pointNumber}`;

    return parts.join(" - ");
  }

  async handleChange(comp) {
    console.log(comp.value);
    await this.setState({ companyId: comp.value });
    await this.formRef.current.setFieldsValue({ companyId: comp.value });
    await this.AssignRouteStore.getVehicles(comp.value);
    await this.AssignRouteStore.getGeoData(comp.value);
    if (!this.props.params.userId) {
      this.context.viewStateStore.setAssignTripStates({
        companyId: comp.value,
      });
    }
    await this.handleSearch();
  }

  async handleSearch() {
    await this.AssignRouteStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }

  onFinish = async (values) => {
    try {
      let AddRoute = {};
      /** ROUTE ID **/
      if (this.state.routeId != null) {
        AddRoute.routeId = this.state.routeId;
      } else {
        AddRoute.routeId = -1;
      }

      /** COMPANY ID **/
      const user = this.props.getUserData();

      if (user.issuperadmin == 1 || user.isadmin == 3) {
        AddRoute.companyId = this.state.companyId;

      } else {
        AddRoute.companyId = user.userCompanyId;
      }

      /** BASIC FIELDS **/
      AddRoute.routename = values.routeName;
      AddRoute.stopSource = values.stopsSource; // array (All / Points / GeoFences)

      /** ROUTE POINTS **/
      let routePoints = [];

      this.state.dragItems.forEach((item, index) => {
        console.log("Processing drag item:", item);
        // debugger
        let obj = {};

        obj.routeZoneId =
          item.routeZoneId ||
          "ext-gen" + Math.floor(Math.random() * 9000 + 1000);

        obj.travelDistance = this.state.travelDistance;
        obj.travelDuration = this.state.travelDuration;

        obj.sequenceNo =
          item.point && item.address
            ? item.point + "-" + item.address
            : item.address;

        obj.address = item.address || "";
        obj.lati = item.lat || "";
        obj.longi = item.lng || "";
        obj.pointName = item.name || item.point || `Point ${index + 1}`;

        routePoints.push(obj);
      });

      console.log("Final routePoints = ", routePoints);

      /** FINAL API CALL */
      const resp = await this.AssignRouteStore.saveRoute({
        AddRoute,
        routePoints,
      });
      if (resp?.data?.success === "S") {

        const isEdit = this.state.routeId && this.state.routeId !== -1;

        if (isEdit) {
          message.success("Route updated successfully");
        } else {
          message.success("Route saved successfully");
        }
        this.context.viewStateStore.setAssignTripStates({
          companyId: this.state.companyId
        });


        /** RESET FORM **/
        if (this.formRef && this.formRef.current) {
          this.formRef.current.resetFields();
        }

        /** RESET DRAG ITEMS (locations list) **/
        this.setState({
          dragItems: [],            // clear all locations
          selectedItemId: null,     // no active selection
          origin: null,
          destination: null,
          pointsWay: [],
          positionLatLongArray: [],
          geofencePointsArrayObj: [],
          travelDistance: "",
          travelTime: "",
          zoomLevel: 10,            // default zoom
        });

        /** RESET MAP (optional) **/
        if (this.state.mapRef) {
          const defaultCenter = {
            lat: config.mapCenter[0],
            lng: config.mapCenter[1],
          };
          this.state.mapRef.panTo(defaultCenter);
          this.state.mapRef.setZoom(10);
        }

        this.props.navigate("/assignroutelist");
      } else {
        message.error("Failed to save route");
      }
    } catch (err) {
      console.log("Error =>", err);
      message.error("Something went wrong");
    }
  };

  handleAddressChange = (val) => {
    if (val === "geofence") {
      this.setState({ geofence: true, searchOnMap: false, history: false });
    } else if (val === "searchOnMap") {
      this.setState({ geofence: false, searchOnMap: true, history: false });
    } else if (val === "history") {
      this.setState({ geofence: false, searchOnMap: false, history: true });
    }
  };

  timeOptions = () => {
    const timeArray = [];

    let startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM
    console.log();
    let endTime = new Date(2000, 0, 1, 23, 30);
    for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
      // const formattedTime = format(time, 'h:mm aa');
      const formattedTime = format(time, "HH:mm:ss");
      var ob = {
        formattedTime: formattedTime,
        time: time,
      };
      timeArray.push(ob);
    }
    console.log(timeArray);
    return timeArray.map((data) => {
      return (
        <Select.Option key={data.formattedTime} value={data.formattedTime}>
          {format(data.time, "h:mm aa")}
        </Select.Option>
      );
    });
  };
  LoadClick = async () => {
    const data = {
      companyId: this.state.companyId,
      vehicleId: this.state.vehicleId,
      fromDate:
        this.state.fromDate.format("YYYY-MM-DD") + " " + this.state.fromTime,
      toDate: this.state.toDate.format("YYYY-MM-DD") + " " + this.state.toTime,
    };
    console.log(data);
    const response = await this.AssignRouteStore.getStopeIdle(data);
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      console.log(response);
    } else {
      message.error();
    }
    this.setState({ update: 1 });
    console.log(data);
  };

  handlePlaceSelected = async (placeDetails) => {
    console.log('handlePlaceSelected');
    //await this.setState({ routePoints: []});
    let routePoints = [];

    var firstRec = this.state.dragItems[0];


    if (firstRec.address) {
      const obj1 = {
        sequenceId: 1,
        routeZoneId: "ext-gen4321",
        routePoint: firstRec.searchAddress,
        sequenceNo: "Start Point- " + firstRec.address,
        address: firstRec.address,
        lati: firstRec.lat,
        longi: firstRec.lng,
        arriveTime: null,
        departureTime: dayjs(this.formRef.current.getFieldValue("startTime")).format("HH:mm"),
        startTime: dayjs(this.formRef.current.getFieldValue("startTime")).format("HH:mm"),
        endTime: null,
        locOption: "Start-Time",
        time: dayjs(this.formRef.current.getFieldValue("startTime")).format("HH:mm"),
        pointName: firstRec.point,
      };
      console.log(obj1);
      this.setState({ startObj: obj1 });

      routePoints.push(obj1);

      //await this.setState({ routePoints: [...this.state.routePoints, obj1] });

    }


    var middlePoints = this.state.dragItems.slice(1, -1);


    if (middlePoints.length > 0) {

      middlePoints.forEach(async (record, index) => {

        const obj2 = {
          routeZoneId: "ext-gen2264" + index,
          routePoint: record.searchAddress,
          sequenceNo: "PickUp Point- " + record.address,
          address: record.address,
          lati: record.lat,
          longi: record.lng,
          arriveTime: this.formRef.current.getFieldValue("arriveTime"),
          departureTime: this.formRef.current.getFieldValue("departureTime"),
          endTime: null,
          time: "00:00",
          locOption: "Pickup/DropTime",
          pointName: record.point,
          wayPointId: index + 1
        };

        this.setState({ pickUpDropObj: obj2 });

        routePoints.push(obj2);



      });

    }
    var lastRec = this.state.dragItems[this.state.dragItems.length - 1];

    if (lastRec.address) {
      const obj3 = {
        sequenceId: 2,
        routeZoneId: "ext-gen2264",
        routePoint: lastRec.searchAddress,
        sequenceNo: "End Point- " + lastRec.address,
        address: lastRec.address,
        lati: lastRec.lat,
        longi: lastRec.lng,
        arriveTime: null,
        departureTime: null,
        endTime: dayjs(this.formRef.current.getFieldValue("endTime")).format("HH:mm"),
        time: dayjs(this.formRef.current.getFieldValue("endTime")).format("HH:mm"),
        locOption: "End-Time",
        pointName: lastRec.point,
      };

      this.setState({ endObj: obj3 });

      routePoints.push(obj3);

    }

    await this.setState({ routePoints: routePoints });

    console.log("routePoints", routePoints);
    console.log("routes**", this.state.routePoints);
    console.log("pickUpDropObj**", this.state.pickUpDropObj);
    console.log("startObj**", this.state.startObj);
    console.log("endObj**", this.state.endObj);

  };

  handleSequenceChange = (val) => {
    // startPoint,endpoint,pickup/drop
    if (val === "startPoint") {
      this.setState({ startPoint: true, endPoint: false, pickUpDrop: false });
    } else if (val === "endPoint") {
      if (!this.state.origin) {
        // Modal.warning({ content: "Please Select Start Point First" });
        Modal.warning({
          content: this.context.translate("_PLEASE_SELECT_START_POINT_FIRST_"),
        });
      } else {
        this.setState({ startPoint: false, endPoint: true, pickUpDrop: false });
      }
    } else if (val === "pickup/drop") {
      if (!this.state.origin) {
        // Modal.warning({ content: "Please Select Start Point First" });
        Modal.warning({
          content: this.context.translate("_PLEASE_SELECT_START_POINT_FIRST_"),
        });
      } else {
        this.setState({ startPoint: false, endPoint: false, pickUpDrop: true });
      }
    }
  };

  addSequenceIntoTable = async () => {
    // console.log(this.state.startObj, this.state.endObj);
    // console.log(this.state.startObj);
    if (!this.state.startObj) {
      Modal.warning({ content: "Please Select Start Point and address." });
    }
    console.log(this.state.startObj);
    let startObj = this.state.startObj;
    console.log(this.state.startObj);
    let endObj = this.state.endObj;
    let pickUpDrop = this.state.pickUpDrop;
    console.log(this.state.endObj, this.state.startObj);
    console.log(pickUpDrop, startObj, endObj);
    // await this.setState({routePoints:[...this.state.routePoints,startObj,endObj,pickUpDrop]})
    if (this.state.companyId) {
      let arr;
      if (this.state.endPoint) {
        console.log(this.state.routePoints, "hello");
        arr = [...this.state.routePoints, endObj];
        console.log(endObj);
        await this.setState({
          routePoints: arr,
          destination: { lat: endObj.lati, lng: endObj.longi },
        });
        // this.setState({ endObj: "", });
      } else if (this.state.startPoint) {
        arr = [startObj];
        console.log(startObj);
        await this.setState({
          routePoints: arr,
          origin: { lat: startObj.lati, lng: startObj.longi },
        });
      } else if (this.state.pickUpDrop) {
        arr = [...this.state.routePoints, this.state.pickUpDropObj];
        console.log(arr);
        await this.setState({
          routePoints: arr,
          // origin: {
          //   lat: this.state.pickUpDropObj?.lati,
          //   lng: this.state.pickUpDropObj?.longi,
          // },
        });
      }
      console.log(arr);
      await this.setState({ addressInputText: "" });
    } else {
      Modal.warning({
        // title: "Alert",
        title: this.context.translate("_FLEET_ALERT_"),
        // content: "Please select Account",
        content: this.context.translate("_PLEASE_SELECT_ACCOUNT_"),
      });
    }
    console.log(this.state.routePoints);
    this.setState({ update: 1 });
  };
  selectCustomer = (val) => {
    if (val === "company") {
      this.setState({ companyCustomer: true, studentCustomer: false });
    } else {
      this.setState({ companyCustomer: false, studentCustomer: true });
    }
  };

  placeChange = async () => {
    if (this.originRef.current) {
      const place = this.originRef.current.getPlace();

      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        await this.setState({
          positionLatLongArray: [
            ...this.state.positionLatLongArray,
            { lat: lat, lng: lng },
          ]
        });


        if (this.state.selectedItemId == "2") {
          this.setState({ destination: { lat: lat, lng: lng } });
        }
        else if (this.state.selectedItemId == "1") {
          this.setState({ origin: { lat: lat, lng: lng } });
        }




        // if (this.state.endPoint) {
        //   this.setState({ destination: { lat: lat, lng: lng } });
        // } else if (this.state.startPoint) {
        //   this.setState({ origin: { lat: lat, lng: lng } });
        // }
        console.log("Formatted Address:", place.formatted_address);
        console.log("Latitude:", lat);
        console.log("Longitude:", lng);
        const addressObject = {
          formattedAddress: place.formatted_address,
          latitude: lat,
          longitude: lng
        };
        this.setState({ addressInputText: place.formatted_address });
        //this.handlePlaceSelected(addressObject);
        this.handlePointsAddressChange(addressObject, "call");



      } else {
        console.log("Location information not available.");
      }
    }
  };
  handleGeofenceObj = async (record) => {
    const arr = record.points.split(",");
    const lat = Number(arr[0]);
    const lng = Number(arr[1]);
    const address = record.address;

    const newPoint = {
      id: String(this.state.dragItems.length + 1),
      point: record.name ? record.name : "Point " + (this.state.dragItems.length + 1),
      address,
      lat,
      lng,
      searchAddress: "Geofence"
    };

    const updatedList = [...this.state.dragItems, newPoint];

    await this.setState({
      dragItems: updatedList,
      selectedItemId: newPoint.id,
      positionLatLongArray: [
        ...this.state.positionLatLongArray,
        { lat, lng }
      ]
    });


    // const originAddress = updatedList[0].address;
    // const destinationAddress = updatedList.length > 1 ? updatedList[updatedList.length - 1].address : null;

    // await this.setState({ originAddress, destinationAddress });

    // call the SAME function: addWayPoints
    this.addWayPoints();

    setTimeout(() => {
      this.mapRef.current?.fitToMarkers?.();
    }, 500);
  };
  handleGeofenceObjOld = async (record) => {

    // Extract center lat/lng of geofence
    const arr = record.points.split(",");
    const lat = Number(arr[0]);
    const lng = Number(arr[1]);
    const address = record.address;

    // Add marker always
    await this.setState({
      positionLatLongArray: [
        ...this.state.positionLatLongArray,
        { lat, lng }
      ]
    });

    // BUILD POINT OBJECT FOR LOCATIONS LIST
    const newPoint = {
      id: String(this.state.dragItems.length + 1),
      point: "Point " + (this.state.dragItems.length + 1),
      address: address,
      lat: lat,
      lng: lng,
      searchAddress: "Geofence"
    };

    // Add the new point in locations list
    const updatedList = [...this.state.dragItems, newPoint];

    await this.setState({
      dragItems: updatedList,
      selectedItemId: newPoint.id
    });

    // ----- ROUTE LOGIC -----
    if (updatedList.length === 1) {
      // First point = origin
      this.setState({
        origin: { lat, lng },
        destination: null,
        pointsWay: []
      });
    }
    else if (updatedList.length === 2) {
      // Second point = destination
      this.setState({
        destination: { lat, lng },
        pointsWay: []
      });
    }
    else if (updatedList.length > 2) {
      // 3rd, 4th etc = waypoints
      const wp = {
        location: { lat, lng },
        wayPointId: updatedList.length - 1
      };

      this.setState({
        pointsWay: [...this.state.pointsWay, wp]
      });
    }

    // Redraw route
    this.addWayPoints();

    setTimeout(() => {
      if (this.mapRef.current && this.mapRef.current.fitToMarkers) {
        this.mapRef.current.fitToMarkers();
      }
    }, 500);

  };
  calculateCenterPoint = (coordinates) => {
    console.log(coordinates);
    if (coordinates && coordinates.length > 0) {
      const latSum = coordinates.reduce(
        (sum, point) => sum + point.latLong[0].lat,
        0
      );
      const lngSum = coordinates.reduce(
        (sum, point) => sum + point.latLong[0].lng,
        0
      );
      const latAvg = latSum / coordinates.length;
      const lngAvg = lngSum / coordinates.length;
      return { lat: latAvg, lng: lngAvg };
    }
    return null;
  };
  handleGeofencePlaceSelect = async (obj) => {
    console.log(obj);
    let placeDetails = obj;
    console.log(this.state.geofenceFormatedPoints);
    let centerPoint = await this.calculateCenterPoint(
      this.state.geofenceFormatedPoints
    );
    console.log(centerPoint);
    await this.setState({
      positionLatLongArray: [
        ...this.state.positionLatLongArray,
        { lat: centerPoint.lat, lng: centerPoint.lng },
      ],
    });

    await this.handleSetPlaces({
      address: placeDetails.address,
      latitude: centerPoint.lat,
      longitude: centerPoint.lng,
    });

    await this.setState({ update: 1 });

    // remaining

    //  let address = await this.AssignRouteStore.getAddressUsingLatLng(centerPoint.lat,centerPoint.lng)
    //  console.log(address)
  };
  handleHistoryAddressSelect = async (obj) => {

    let placeDetails = obj;
    await this.setState({
      positionLatLongArray: [
        ...this.state.positionLatLongArray,
        { lat: Number(placeDetails.latitude), lng: Number(placeDetails.longitude) },
      ],
    });

    if (this.state.selectedItemId == "2") {
      this.setState({ destination: { lat: Number(placeDetails.latitude), lng: Number(placeDetails.longitude) } });
    }
    else if (this.state.selectedItemId == "1") {
      this.setState({ origin: { lat: Number(placeDetails.latitude), lng: Number(placeDetails.longitude) } });
    }

    const addressObject = {
      formattedAddress: placeDetails.stopIdleLocation,
      latitude: Number(placeDetails.latitude),
      longitude: Number(placeDetails.longitude),
    };
    //this.setState({ addressInputText: place.stopIdleLocation });
    this.handlePointsAddressChange(addressObject, "call");

  };
  handleHistoryPlaceSelect = (obj) => {
    console.log(obj);
    let placeDetails = obj;
    this.handleSetPlaces({
      address: placeDetails.stopIdleLocation,
      latitude: Number(placeDetails.latitude),
      longitude: Number(placeDetails.longitude),
    });
  };
  handleSetPlaces = async ({ address, latitude, longitude }) => {

    console.log(address, latitude, longitude, this.state.startPoint);
    console.log(this.state.start, this.state.end);
    if (this.state.startPoint) {
      const obj = {
        sequenceId: 1,
        routeZoneId: "ext-gen4321",
        routePoint: "Geofence",
        sequenceNo: "Start Point-" + address,
        address: address,
        lati: latitude,
        longi: longitude,
        arriveTime: null,
        departureTime: dayjs(
          this.formRef.current.getFieldValue("startTime")
        ).format("HH:mm"),
        endTime: null,
        locOption: "Start-Time",
        time: dayjs(this.formRef.current.getFieldValue("startTime")).format(
          "HH:mm"
        ),
      };
      console.log(obj);
      await this.setState({ startObj: obj });
      await this.setState({ update: 1 });
    } else if (this.state.endPoint) {
      const obj = {
        sequenceId: 2,
        routeZoneId: "ext-gen2264",
        routePoint: "Geofence",
        sequenceNo: "End Point-" + address,
        address: address,
        lati: latitude,
        longi: longitude,
        arriveTime: dayjs(this.formRef.current.getFieldValue("endTime")).format(
          "HH:mm"
        ),
        departureTime: null,
        endTime: null,
        time: dayjs(this.formRef.current.getFieldValue("endTime")).format(
          "HH:mm"
        ),
        locOption: "End-Time",
      };
      console.log("hello");
      this.setState({ endObj: obj });
    } else if (this.state.pickUpDrop) {
      await this.setState({ wayPointId: this.state.wayPointId + 1 });
      const obj = {
        routeZoneId: "ext-gen2264",
        routePoint: "Geofence",
        sequenceNo: "PickUp Point-" + address,
        address: address,
        lati: latitude,
        longi: longitude,
        arriveTime: null,
        departureTime: null,
        endTime: null,
        time: "00:00",
        locOption: "Pickup/Drop-Time",
        wayPointId: this.state.wayPointId,
      };

      await this.setState({ pickUpDropObj: obj });
      console.log([
        ...this.state.pointsWay,
        {
          location: { lat: latitude, lng: longitude },
          wayPointId: this.state.wayPointId,
        },
      ]);
      await this.setState({
        pointsWay: [
          ...this.state.pointsWay,
          {
            location: {
              lat: latitude,
              lng: longitude,
            },
            wayPointId: this.state.wayPointId,
          },
        ],
      });

    }
    await this.setState({ loadState: 1 });
  };

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const draggedIndex = result.destination.index;

    const dragItems = this.reorder(
      this.state.dragItems,
      result.source.index,
      result.destination.index
    );

    this.setState({
      dragItems
    }, () => {
      // ✅ Update origin and destination addresses after reorder
      const originAddress = dragItems[0].address;
      const destinationAddress = dragItems.length > 1 ? dragItems[dragItems.length - 1].address : null;

      this.setState({ originAddress, destinationAddress }, () => {
        // Now that the state has been updated, call addWayPoints here
        if (dragItems.length >= 3) {
          this.addWayPoints();
        }

        if (this.mapRef?.current?.bounceMarker) {

          let keyToBounce = null;

          if (draggedIndex === 0) {
            keyToBounce = "origin";
          }
          else if (draggedIndex === dragItems.length - 1) {
            keyToBounce = "destination";
          }
          else {
            const waypoint = dragItems[draggedIndex];
            keyToBounce = `wp_${waypoint.id}`;
          }

          this.mapRef.current.bounceMarker(keyToBounce);
        }
        //this.handlePlaceSelected(null);
      });
    });
  };

  // a little function to help us with reordering the result
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    // result.forEach((item, index) => {
    //   item.index = index;
    // });

    return result;
  };


  handlePointsAddressChange = async (addressObject, param) => {
    let searchAdd = "";
    if (this.state.geofence) {
      searchAdd = "Geofence"
    }
    else if (this.state.searchOnMap) {
      searchAdd = "Search On Map"
    }
    else if (this.state.history) {
      searchAdd = "History"
    }

    this.setState((prevState) => {
      const updatedDragItems = prevState.dragItems.map((item) =>
        item.id === this.state.selectedItemId ? { ...item, address: addressObject.formattedAddress, lat: addressObject.latitude, lng: addressObject.longitude, searchAddress: searchAdd } : item
      );

      return { dragItems: updatedDragItems };
    }, () => {
      // Now that the state has been updated, call addWayPoints here
      if (param == "call") {
        if (this.state.dragItems.length >= 3) {
          this.addWayPoints();
        }
      }


      this.handlePlaceSelected(null);

    });
  };

  addNewPoints = async (newAddress) => {     // On click of add new points button

    try {
      const lastRecord = this.state.dragItems[this.state.dragItems.length - 1];

      const newPoint = {
        id: String(Number(lastRecord.id) + 1),
        point: `Point ${String(Number(lastRecord.id) + 1)}`,
        address: "",
        lat: "",
        lng: ""
      };

      let id = String(Number(lastRecord.id) + 1);


      this.formRef.current.setFieldsValue({ pointName: newPoint.point });

      this.setState({ selectedItemId: id });

      this.setState({ addressInputText: "" });

      this.setState((prevState) => ({
        dragItems: [...prevState.dragItems, newPoint],
      }));
    } catch (error) {
      console.error("Error in addNewPoints:", error);
    }

  };

  addWayPoints = async () => {
    console.log("addWayPoints");

    const items = this.state.dragItems;
    if (!items || items.length === 0) return;

    const originRec = items[0];
    const destinationRec = items[items.length - 1];
    const middlePoints = items.slice(1, -1);

    // Set Origin
    await this.setState({
      origin: {
        lat: Number(originRec.lat),
        lng: Number(originRec.lng)
      }
    });

    // Set Destination only if 2 or more items
    if (items.length > 1) {
      await this.setState({
        destination: {
          lat: Number(destinationRec.lat),
          lng: Number(destinationRec.lng)
        }
      });
    } else {
      await this.setState({ destination: null });
    }

    // Build Waypoints
    const wayPoints = middlePoints.map((rec, index) => ({
      location: {
        lat: Number(rec.lat),
        lng: Number(rec.lng)
      },
      wayPointId: index + 2,
      address: rec.address
    }));

    await this.setState({
      pointsWay: wayPoints,
      loadState: 1
    });

    await this.setState({
      originAddress: originRec.address,
      destinationAddress: destinationRec.address
    });


    console.log("origin:", this.state.origin);
    console.log("destination:", this.state.destination);
    console.log("pointsWay:", this.state.pointsWay);
  };
  addWayPointsOld = async () => {

    console.log('addWayPoints');
    var firstRec = this.state.dragItems[0];

    this.setState({ origin: { lat: Number(firstRec.lat), lng: Number(firstRec.lng) } });

    var middlePoints = this.state.dragItems.slice(1, -1);

    var lastRec = this.state.dragItems[this.state.dragItems.length - 1];

    this.setState({ destination: { lat: Number(lastRec.lat), lng: Number(lastRec.lng) } });

    await this.setState({
      //wayPointId: prevState.wayPointId + 1,
      pointsWay: [],
    });

    const wayPoints = await middlePoints.map((record, index) => {

      const pointsway = {
        location: {
          lat: Number(record.lat),
          lng: Number(record.lng),
        },
        wayPointId: index + 2
      };

      return pointsway;

    });

    console.log("wayPoints**", wayPoints);

    await this.setState({ pointsWay: wayPoints });

    console.log("origin**", this.state.origin);
    console.log("destination**", this.state.destination);

    await this.setState({ loadState: 1 });
  }


  Showhidecomp = (index) => {

    if (index == 0) {

      this.setState({ startPoint: true });
      this.setState({ endPoint: false });
      this.setState({ pickUpDrop: false });

    } else if (index == this.state.dragItems.length - 1) {

      this.setState({ startPoint: false });
      this.setState({ endPoint: true });
      this.setState({ pickUpDrop: false });

    } else {
      this.setState({ startPoint: false });
      this.setState({ endPoint: false });
      this.setState({ pickUpDrop: true });
    }

  }

  handleDeletePointsOld = async (e, itemId) => {
    e.stopPropagation();
    const updatedDragItems = this.state.dragItems.filter(item => item.id !== itemId);

    await this.setState({ dragItems: updatedDragItems });

    console.log("dragItemsondelete", this.state.dragItems);
  };



  handleStopsSourceChange = async (values) => {
    const companyId = this.state.companyId;
    let finalList = [];

    if (!companyId) {
      message.warning("Please select Account first");
      return;
    }

    // console.log(object)

    // POINTS SELECTED → getPoi()
    if (values.includes("2")) {
      const poiResp = await this.AssignRouteStore.getPoi(companyId);
      console.log(poiResp)
      if (poiResp?.data?.data) {
        finalList = [...finalList, ...poiResp.data?.data];
      }
    }

    // GEOFENCES SELECTED → getGeoData()
    if (values.includes("3")) {
      const geoResp = await this.AssignRouteStore.getGeoData(companyId);
      if (geoResp?.data?.geofence) {

        const mappedGeofence = geoResp.data.geofence.map((item) => {

          let lat = null, lng = null;

          if (item.points) {
            const arr = item.points.split(",");
            lat = Number(arr[0]);
            lng = Number(arr[1]);
          }

          return {
            zoneId: item.zoneId,
            name: item.name || "Geofence",
            address: item.address || "",
            points: item.points,
            lat: lat,
            lng: lng,
            type: "geofence",
          };
        });

        finalList = [...finalList, ...mappedGeofence];
      }
    }

    // ALL SELECTED → both APIs
    if (values.includes("1")) {
      const poiResp = await this.AssignRouteStore.getPoi(companyId);
      const geoResp = await this.AssignRouteStore.getGeoData(companyId);

      if (poiResp?.data) finalList = [...finalList, ...poiResp.data];

      if (geoResp?.data?.geofence) {
        const mappedGeofence = geoResp.data.geofence.map((item) => {

          let lat = null, lng = null;

          if (item.points) {
            const arr = item.points.split(",");
            lat = Number(arr[0]);
            lng = Number(arr[1]);
          }

          return {
            zoneId: item.zoneId,
            name: item.name || "Geofence",
            address: item.address || "",
            points: item.points,
            lat: lat,
            lng: lng,
            type: "geofence",
          };
        });


        finalList = [...finalList, ...mappedGeofence];
      }


    }

    // Set to state → for Source dropdown
    this.setState({ sourcesList: finalList });
  }

  updateDistanceTime = (distance, time) => {
    this.setState({
      travelDistance: distance,
      travelDuration: time
    });
  };

  formatAddress = (sequenceNo) => {
    if (!sequenceNo) return "";

    // Split only on the first dash
    const firstDashIndex = sequenceNo.indexOf("-");

    if (firstDashIndex === -1) return sequenceNo; // no dash found

    return sequenceNo.substring(firstDashIndex + 1).trim();
  };



  handleDeletePoints = async (e, id) => {
    const { dragItems, routePoints, geofencePointsArrayObj } = this.state;

    // Filter out the deleted point
    const newDragItems = dragItems.filter(x => x.id !== id);
    const newRoutePoints = routePoints?.filter(x => x.id !== id);
    const newGeofencePoints = geofencePointsArrayObj?.filter(x => x.sequenceId !== id);

    // Update dragItems
    await this.setState({
      dragItems: newDragItems,
      routePoints: newRoutePoints,
      geofencePointsArrayObj: newGeofencePoints,
    });


    // ---------- UPDATE ORIGIN ----------
    let origin = null;
    let originAddress = "";

    if (newDragItems.length >= 1) {
      origin = {
        lat: newDragItems[0].lat,
        lng: newDragItems[0].lng,
      };
      originAddress = newDragItems[0].address;   // ⭐ IMPORTANT
    }

    // ---------- UPDATE DESTINATION ----------
    let destination = null;
    let destinationAddress = "";

    if (newDragItems.length >= 2) {
      const last = newDragItems[newDragItems.length - 1];
      destination = { lat: last.lat, lng: last.lng };
      destinationAddress = last.address;          // ⭐ IMPORTANT
    }

    // ---------- UPDATE WAYPOINTS ----------
    let pointsWay = [];
    if (newDragItems.length > 2) {
      pointsWay = newDragItems.slice(1, -1).map((p, i) => ({
        id: p.id,
        wayPointId: i + 1,
        address: p.address,
        location: { lat: p.lat, lng: p.lng },
      }));
    }

    await this.setState({ origin, destination, pointsWay, originAddress, destinationAddress });

    // Remove polyline if not enough points
    if (!origin || !destination) {
      this.setState({ directonResponse: null });
    }
  };



  render() {
    return (
      <>
        <GoogleMapForDirection
          origin={this.state.origin}
          destination={this.state.destination}
          wayPoints={this.state.pointsWay}
          onPlaceSelected={this.handlePlaceSelected}
          geofencePointsArrayObj={this.state.geofencePointsArrayObj}
          This={this}
          positions={this.state.positionLatLongArray}
          mapRef={this.mapRef}
          updateDistanceTime={this.updateDistanceTime}
          disableDragging={true}
          handleDeletePoints={this.handleDeletePoints}
          isIconVisible={true}
          routeColor="#2196F3"
          enableNewDistanceLogic={true}
        ></GoogleMapForDirection>


        <Form
          ref={this.formRef}
          style={{ padding: 0 }}
          layout="vertical"
          onFinish={this.onFinish}
          // {...this.layout}

          name="nest-message"
          initialValues={{
            fromDate: dayjs(),
            toDate: dayjs(),
            validFrom: dayjs(),
            validTo: dayjs(),
            routestartDate: dayjs(),
            routestopDate: dayjs(),
            startTime: dayjs("00:00", "HH:mm"),
            endTime: dayjs("00:00", "HH:mm"),
          }}
        >
          {/* <h1>Create/Assign Trip</h1> */}
          <div style={{ display: "flex" }}>
            <Spin spinning={this.state.loadingSpinner}>
              <div
                className="leftWhite-form-panel"
                style={{
                  width: 350,
                  height: "calc(100vh)",
                  display: "flex",
                  flexDirection: "column",
                  background: "#fff",
                  borderRight: "1px solid #ddd"
                }}
              >

                {/* TITLE FIXED */}
                <div
                  style={{
                    padding: "12px 15px",
                    borderBottom: "1px solid #e6e6e6",
                    fontSize: 18,
                    fontWeight: 600
                  }}
                >
                  Create Route
                </div>

                {/* SCROLLABLE CONTENT */}
                <div
                  style={{
                    flex: 1,
                    overflowY: "auto",
                    padding: "10px 15px",
                  }}
                >

                  {/* COLLAPSIBLE PANEL */}
                  <Collapse defaultActiveKey={["1"]} style={{ marginBottom: 15 }}>
                    <Collapse.Panel header="Main Details" key="1" bodyStyle={{ paddingTop: 5 }}>
                      <div style={{ marginTop: -18 }}>

                        {(this.props.getUserData().isadmin === -1 ||
                          this.props.getUserData().isadmin === 3) && (
                            <Form.Item
                              name="companyId"
                              label="Account"
                              rules={[{ required: true }]}
                              style={{ marginBottom: 6 }}
                            >
                              <CompanyAutocomplete
                                onChange={(value) => this.handleChange(value)}
                                style={{ width: "100%" }}
                                companyId={this.state.companyId}
                              />
                            </Form.Item>
                          )}

                        <Form.Item
                          name="routeName"
                          label="Route Name"
                          rules={[{ required: true }]}
                          style={{ marginBottom: 6 }}
                        >
                          <Input placeholder="Enter route name" />
                        </Form.Item>

                        <Form.Item
                          name="stopsSource"
                          label="Stops Source"
                          rules={[{ required: true }]}
                          style={{ marginBottom: 6 }}
                        >
                          <Select mode="multiple"
                            placeholder="Select stops source"
                            onChange={(values) => this.handleStopsSourceChange(values)}

                          >
                            <Select.Option value="1">All</Select.Option>
                            <Select.Option value="2">Points</Select.Option>
                            <Select.Option value="3">Geofences</Select.Option>
                          </Select>
                        </Form.Item>

                        <Form.Item
                          name="sourceType"
                          label="Source"
                          rules={[{ required: false }]}
                          style={{ marginBottom: 6 }}
                        >
                          <Select placeholder="Select source"
                            showSearch
                            onSelect={async (val, e) => {
                              await this.handleGeofenceObj(e.obj);
                            }}
                            filterOption={(inputValue, option) => {
                              return (
                                option.children
                                  .toLowerCase()
                                  .indexOf(inputValue.toLowerCase()) >= 0
                              );
                            }}
                          >
                            {this.state.sourcesList.map((item, index) => (
                              <Select.Option key={index} value={item.zoneId} obj={item}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Collapse.Panel>
                  </Collapse>

                  {/* LOCATIONS */}
                  <div className="add-checkpoint-wrapper">
                    <DragDropContext onDragEnd={this.onDragEnd}>
                      <Droppable droppableId="droppable">
                        {(provided) => (
                          <div
                            className="add-checkpoint-inner"
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {/* 🔥 EMPTY LIST PLACEHOLDER MESSAGE */}
                            {this.state.dragItems.length === 0 && (
                              <div
                                style={{
                                  textAlign: "center",
                                  padding: "20px 10px",
                                  color: "#999",
                                  fontSize: 14,
                                  fontStyle: "italic"
                                }}
                              >
                                Your selected locations will appear here
                              </div>
                            )}



                            {this.state.dragItems.map((item, index) => (
                              <Draggable key={item.id} draggableId={item.id} index={index}>
                                {(provided_) => (
                                  <div
                                    ref={provided_.innerRef}
                                    {...provided_.draggableProps}
                                    {...provided_.dragHandleProps}
                                    className={
                                      this.state.selectedItemId === item.id
                                        ? "checkpoint-list active-checkpoint"
                                        : "checkpoint-list"
                                    }
                                    onClick={() => {
                                      this.setState({ selectedItemId: item.id });
                                      this.setState({ addressInputText: item.address });
                                      this.formRef.current.setFieldsValue({ pointName: item.point });
                                      this.Showhidecomp(index);
                                    }}
                                  >
                                    {/* {this.state.dragItems.length > 2 && ( */}
                                    <Popconfirm
                                      title="Delete this point?"
                                      onConfirm={(e) => this.handleDeletePoints(e, item.id)}
                                      okText="Yes"
                                      cancelText="No"
                                    >
                                      <div className="checkpoint-close">
                                        <CloseOutlined />
                                      </div>
                                    </Popconfirm>
                                    {/* )} */}

                                    <span>{index + 1}</span>
                                    <p>
                                      <b>{item.point}</b>
                                      <small>
                                        {item.address === ""
                                          ? " Address not specified"
                                          : item.address}
                                      </small>
                                    </p>
                                  </div>
                                )}
                              </Draggable>
                            ))}

                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>

                  {/* OPTIMIZE BOX */}
                  <div
                    style={{
                      marginTop: 20,
                      padding: 15,
                      border: "1px solid #e0e0e0",
                      borderRadius: 8,
                      background: "#f7f7f7",
                    }}
                  >
                    <h4 style={{ marginBottom: 10 }}>Tap to Optimize</h4>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Distance:</span>
                      <b>{this.state.travelDistance || "—"}</b>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Time:</span>
                      <b>{this.state.travelDuration || "—"}</b>
                    </div>


                  </div>

                </div>

                {/* FIXED BOTTOM BUTTONS */}
                <div
                  style={{
                    padding: "12px 15px",
                    borderTop: "1px solid #ddd",
                    background: "#fff",
                    display: "flex",
                    gap: 10,
                    position: "sticky",
                    bottom: 0,
                    zIndex: 999,
                  }}
                >
                  <Button
                    style={{ width: "50%" }}
                    onClick={() => this.props.navigate("/assignroutelist")}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="primary"
                    style={{ width: "50%" }}
                    htmlType="submit"
                  >
                    Save
                  </Button>
                </div>

              </div>
            </Spin>
          </div>
        </Form>


      </>
    );
  }
}

AssignRouteAddNew.contextType = StoreContext;
export default observer(withRouter(AssignRouteAddNew));